import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { TestimonialCaptureAPI } from '../../services/testimonialCaptureAPI';
import { VideoAPI } from '../../services/videoAPI';


@inject(Router, VideoAPI)
export class LinkSubmissionStart {
    constructor(router, videoApi) {
        this.router = router;
        this.videoApi = videoApi;

        this.capture_key = null;
        

        this.showVideo = false;



    
        this.capture_bottom_img = "images/capture_bottom.png";

        this.app_name = "Magnfi";
        this.home_url = window.home_url;
        this.logo_img = "images/magnfi-logo-small.png";

        if (window.whitelabel) {
            this.capture_bottom_img = "api/whitelabel/getFile?file=capture_bottom";
            this.app_name = window.app_name;
            this.logo_img = "api/whitelabel/getFile?file=site_logo";
        }

        if(window.private_label == 1)
        {
            this.private_label =1;
        }

    }


    activate(model) {

    
        this.capture_key = model.key;

        

    }

    attached() {
       
      
        this.videoApi.getPublicVideosList(this.capture_key, this.getPublicVideosSuccess.bind(this), this.saveLoadError.bind(this));

    }


    getPublicVideosSuccess(videos, org_name, website) {
        this.publicVideos = videos;
        this.org_name = org_name;
        this.website = website;
    }

    showVideoClicked(url, videoType, videoId) {

        this.videoApi.updateReviewPageVideoPlayCount(videoType, videoId, () => {

        }, () => {

        } );
        this.showVideo = true;
        this.videoPlayer.src = url;
        this.videoPlayer.load();
        this.videoPlayer.play();
    }

    showVideoClosed() {
        this.showVideo = false;
        if (this.videoPlayer) {
            this.videoPlayer.pause();
        }
    }

    saveLoadError(msg) {

        if(msg == "invalid key")
            this.router.navigate("/");
        else
            this.reportError(msg);

    }

    submitVideoClicked() {
        this.router.navigate('#/capture/link/' + this.capture_key);
    }




}